<h1 class="font-app-bold text-darkest text-sm md:text-base">
  {{ "warrantyOptions" | translate }}
</h1>

<div *ngFor="let item of displayedOptions">
  <div class="flex items-end mt-3">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
        {{ getOptionLabel(item.type) | translate }}
      </span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest">
      {{ (!item.isSelected ? "generalOptions.no" : "generalOptions.yes") | translate }}
    </span>
  </div>
</div>
